// Section 24.12: contentVersion is a hash of the registries' static data (hooks are functions
// and drop out of JSON), so saves can tell when content changed.
import { hashString } from '../core/rng';
import { registry } from '../content';

let cached: string | null = null;

export function contentVersion(): string {
  if (cached !== null) return cached;
  const { pipeline: _pipeline, contributors: _contributors, ...defs } = registry;
  cached = hashString(JSON.stringify(defs)).toString(16).padStart(8, '0');
  return cached;
}
